import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assests/css/Home.css";

const BookTaxiNow = () => {
  const [state, setState] = useState({
    pickup: "",
    dropoff: "",
  });

  const InputVal = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleBooking = () => {
    // window.location.replace("https://eb3.autocab.net/#/33710");
    window.open("https://eb3.autocab.net/#/33710", "_blank");
  };

  return (
    <div>
      <div className="container">
        <p className="red-clr f-16  mt-2 f-pop-med">
          Professional and Reliable Stansted Airport Transfers Services{" "}
        </p>
        <p className="blu-clr-book f-47 lh-1 f-pop-med">
          Book Your Ride in 1-Minute
        </p>
        <div className="row mt-4 pt-2 mb-5 pb-5">
          <div className="col-lg-5 mt-res-cus">
            <input
              value={state.pickup || ""}
              name="pickup"
              onChange={InputVal}
              type="text"
              placeholder="Pick Up Address"
              className="form-control tx-field f-14  f-pop-med"
            />
          </div>
          <div className="col-lg-5 mt-res-cus">
            <input
              value={state.dropoff || ""}
              name="dropoff"
              onChange={InputVal}
              type="text"
              placeholder="Drop Off Address"
              className="form-control tx-field f-14  f-pop-med"
            />
          </div>
          <div className="col-lg-2 mt-res-cus">
            {/* <Link to="/booking" className='link_ourfleet'>
                            <button className='btn btn-danger red-clr-btn p-bt-cus f-14 f-pop-med '>Proceed</button>
                        </Link> */}
            <a className="link_ourfleet">
              <button
                className="btn btn-danger red-clr-btn p-bt-cus f-14 f-pop-med "
                onClick={handleBooking}
              >
                Proceed
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookTaxiNow;
